import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { breakpoints } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'
import { Button } from '@/components/button'
import { ShareIcon } from '@/components/icons'

const StyledButton = styled(Button)`
  gap: 0 8px;
  border-radius: 4px;
`

const ShareButton = ({ style, disabled = false, showModal, setShareListingButtonClicked }) => {
  const { t } = useTranslation()
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.phoneMax})`)
  const padding = isMobile ? '8px 16px' : '12px 20px'

  return (
    <StyledButton
      minHeight="44px"
      minWidth="89px"
      padding={padding}
      size="small"
      onClick={() => {
        showModal()
        setShareListingButtonClicked()
      }}
      id="listing-dashboard-share-button-click"
      style={style}
      disabled={disabled}
    >
      <ShareIcon />
      {t('common.share', 'Share')}
    </StyledButton>
  )
}

export default ShareButton
